import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import _get from 'lodash/get';
import { selectDoesUserHaveRbacPermission } from 'core/userContext/selectors';
import { getCatalogName } from 'modules/catalogTable/selectors';
import { fetchPaginatedCatalogItems } from 'modules/catalogTable/actions';
import { PROJECT_PERMISSIONS } from 'utils/permissions';
import CatalogFieldTypes from './FieldTypes';
import {
  selectBreadcrumbsForFieldTypes,
  selectFieldTypeTableRows,
  getCatalogFieldTypesUndefined,
  selectSampleData,
} from '../selectors';
import { fetchCatalogFieldTypesRequest, updateAndFetchFieldTypes } from '../actions';

// type Props = {
//   catalogName: ?string,
//   fetchPaginatedCatalogItems: (string, ?Object) => void,
//   fetchCatalogFieldTypesRequest: (*) => void,
//   match: *,
// };

export class CatalogFieldTypesContainer extends React.Component {
  componentDidMount() {
    if (!this.props.catalogName) {
      // fetch catalog
      this.props.fetchPaginatedCatalogItems(this.props.match.params.tableName);
    }
    this.fetchFieldTypes();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.url !== this.props.match.url) {
      this.fetchFieldTypes();
    }
  }

  fetchFieldTypes() {
    const { match } = this.props;
    const tableName = _get(match, 'params.tableName');
    this.props.fetchCatalogFieldTypesRequest(tableName);
  }

  render() {
    return <CatalogFieldTypes {...this.props} />;
  }
}

const mapStateToProps = (state) => ({
  canManageCatalogs: selectDoesUserHaveRbacPermission(state)(PROJECT_PERMISSIONS.ManageCatalogs),
  component: CatalogFieldTypes,
  catalogName: getCatalogName(state),
  breadcrumbs: selectBreadcrumbsForFieldTypes(state),
  rows: selectFieldTypeTableRows(state),
  undefinedFields: getCatalogFieldTypesUndefined(state),
  sampleData: selectSampleData(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchPaginatedCatalogItems,
      fetchCatalogFieldTypesRequest,
      updateAndFetchFieldTypes,
    },
    dispatch,
  );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CatalogFieldTypesContainer));
